export const PAGE_LAYOUT_FILL = "fill" as const
export const PAGE_LAYOUT_SCROLL = "scroll" as const

export type PageLayoutMode = typeof PAGE_LAYOUT_FILL | typeof PAGE_LAYOUT_SCROLL

type PageLayoutHandleKey = "adminLayout" | "siteLayout"

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value)

/**
 * Deepest route match with a known fill/scroll handle wins.
 * Missing / unknown handles fall back to fill (list grids, Sigma embeds).
 */
export const resolvePageLayoutMode = (
  matches: readonly { handle?: unknown }[],
  handleKey: PageLayoutHandleKey
): PageLayoutMode => {
  for (let index = matches.length - 1; index >= 0; index -= 1) {
    const handle = matches[index]?.handle
    if (!isRecord(handle)) {
      continue
    }

    const mode = handle[handleKey]
    if (mode === PAGE_LAYOUT_FILL || mode === PAGE_LAYOUT_SCROLL) {
      return mode
    }
  }

  return PAGE_LAYOUT_FILL
}
